import { HStack, Button, Spacer, Text, Image } from '@chakra-ui/react'
import { MdLogout } from 'react-icons/md'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import LogoImage from '@images/external_payment/logo.webp'

export const BrandBar = ({ onLogout, isLogoutLoading = false, onLogoClick }) => (
  <HStack w="100%" h="44px" px={4} borderBottom="1px" borderColor="divider.light" bg="white">
    <Image alt="マンガBANG!ショップ" src={buildAssetUrlString(LogoImage)} htmlWidth="173" onClick={onLogoClick} cursor={onLogoClick ? 'pointer' : 'default'} />
    <Spacer />
    {onLogout && (
      <Button
        aria-label="ログアウト"
        variant="ghost"
        size="sm"
        color="label.secondary"
        onClick={onLogout}
        leftIcon={<MdLogout size={18} />}
        px={2}
        h="32px"
        isDisabled={isLogoutLoading}
      >
        <Text fontSize="xs">ログアウト</Text>
      </Button>
    )}
  </HStack>
)
